module.exports = __webpack_public_path__ + "img/checkcircle.a2dfa5ca.svg";